import { render } from "./Respuesta.vue?vue&type=template&id=235fbe64"
import script from "./Respuesta.vue?vue&type=script&lang=js"
export * from "./Respuesta.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__